import React, { useContext, useEffect, useRef, useState } from "react";
import "../../css_files/Orders/Orders.css";
import axiosInstance from "../../api";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import Pagination from "../Homepage/Pagination";
import { triggerscroll } from "../Homepage/Homepage";
import moment from "moment";

function Orders() {
  const [ordersData, setOrdersData] = useState([]);
  const nav = useNavigate();
  const [refresh, setrefresh] = useState(false);
  const [loading, setloading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setpage] = useState(1);
  const [pages, setpages] = useState(0);
  const [edit, setEdit] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");
  const [count, setCount] = useState(0);
  const [floppyLoading, setFloppyLoading] = useState(false);
  const { userData, permissionsdata } = useContext(triggerscroll);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/Orders?page=${page}`)
      .then(async (res) => {
        setpages(res.data.pages);
        setCount(res.data.count);
        setEdit(Array.from({ length: res.data.data.length }, () => false));

        setOrdersData(res.data.data);
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
      });
  }, [refresh, page]);

  const tableRef = useRef();

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Order" && x.isRead === true
    );
    return issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Order" && x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Order" && x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="orders">
      <h1>Orders</h1>
      <blockquote>
        <input
          type="search"
          placeholder="Enter Order Id or Quotation Id"
          onChange={(e) => setSearchTerm(e.target.value)}
          onInput={(e) => {
            if (e.target.value === "") {
              setrefresh(!refresh);
            }
          }}
        />
        <button
          onClick={() => {
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/Orders/SearchOrder?searchTerm=${searchTerm}`
              )
              .then((res) => {
                setOrdersData(res.data);
              })
              .catch(console.log);
          }}
        >
          <i className="fa-solid fa-search"></i>
        </button>
      </blockquote>
      <br />
      <blockquote className="navigate-left-right-bottom-table">
        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: -tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>
        <p>{count} records</p>
        <button
          onClick={() => {
            tableRef.current.scrollBy({
              left: tableRef.current.scrollWidth,
              behavior: "smooth",
            });
          }}
        >
          <i className="fa-solid fa-arrow-right"></i>
        </button>
      </blockquote>

      <div className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(10, 1fr)" }}>
              <blockquote style={{ minWidth: "5rem" }}>Order Id</blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Quotation Id
              </blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Payment Method
              </blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Payment Mode
              </blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Transaction / Reference Id
              </blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Total Amount to Pay
              </blockquote>
              <blockquote style={{ minWidth: "10rem" }}>Amount Paid</blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Transaction Status
              </blockquote>
              <blockquote style={{ minWidth: "10rem" }}>
                Payment Date
              </blockquote>
              <blockquote style={{ minWidth: "5rem" }}>Actions</blockquote>
            </aside>
          </div>
          <div>
            {readPermission() ? (
              loading ? (
                <aside style={{ gridTemplateColumns: "repeat(10, 1fr)" }}>
                  <blockquote style={{ gridColumn: "span 10" }}>
                    <center>
                      <i
                        class="fa-solid fa-snowflake fa-spin"
                        style={{ fontSize: "2.5rem" }}
                      ></i>
                    </center>
                  </blockquote>
                </aside>
              ) : ordersData.length > 0 ? (
                ordersData.map((order, index) => (
                  <aside style={{ gridTemplateColumns: "repeat(10, 1fr)" }}>
                    <blockquote style={{ minWidth: "5rem" }}>
                      {order.id}
                    </blockquote>
                    <blockquote style={{ minWidth: "10rem" }}>
                      {order.quotationId}
                    </blockquote>
                    <blockquote style={{ minWidth: "10rem" }}>
                      {order.paymentMethod}
                    </blockquote>
                    <blockquote style={{ minWidth: "10rem" }}>
                      {order.paymentMode}
                    </blockquote>
                    <blockquote style={{ minWidth: "10rem" }}>
                      {order.transactionId || "N/A"}
                    </blockquote>
                    <blockquote style={{ minWidth: "10rem" }}>
                      {order?.quotation?.symbol} {order.totalAmountToPay}
                    </blockquote>
                    <blockquote style={{ minWidth: "10rem" }}>
                      {order?.quotation?.symbol} {order.amountPaid}
                    </blockquote>
                    <blockquote
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "0.5rem",
                        width: "10rem",
                      }}
                    >
                      {edit[index] ? (
                        <>
                          <select
                            onChange={(e) => {
                              setOrderStatus(e.target.value);
                            }}
                          >
                            <option value="">Select Status</option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                          </select>
                          {floppyLoading ? (
                            <i className="fa-solid fa-rotate-right fa-spin"></i>
                          ) : (
                            <>
                              <i
                                className="fa-solid fa-floppy-disk"
                                onClick={() => {
                                  if (orderStatus === "") {
                                    toast.warning(
                                      "Please Select Order Status",
                                      {
                                        position: "bottom-center",
                                        theme: "dark",
                                      }
                                    );
                                    return;
                                  }
                                  setFloppyLoading(true);
                                  axiosInstance
                                    .put(
                                      `${process.env.REACT_APP_API_URL}/api/Orders/UpdateOrder`,
                                      {
                                        Id: order.id,
                                        IsActive: orderStatus === "Active",
                                      }
                                    )
                                    .then((res) => {
                                      toast.success(
                                        "Order/Transaction Status Changed Successfully",
                                        {
                                          position: "bottom-center",
                                          theme: "dark",
                                        }
                                      );
                                      setrefresh(!refresh);
                                    })
                                    .catch(console.log)
                                    .finally(() => {
                                      setFloppyLoading(false);
                                      setEdit((prev) => prev.map((_) => false));
                                    });
                                }}
                              ></i>
                              <i
                                className="fa-solid fa-xmark"
                                onClick={() =>
                                  setEdit((prev) => prev.map((_) => false))
                                }
                              ></i>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {order.isActive ? "Active" : "Inactive"}{" "}
                          <i
                            className="fa-solid fa-pen-to-square"
                            onClick={() =>
                              setEdit((prev) => prev.map((_, j) => j === index))
                            }
                            style={{
                              pointerEvents: updatePermission() && "none",
                              color: updatePermission() && "gray",
                            }}
                          ></i>
                        </>
                      )}
                    </blockquote>
                    <blockquote style={{ minWidth: "10rem" }}>
                      {moment(new Date(order.paymentDate)).format("DD/MM/YYYY")}
                    </blockquote>
                    <blockquote
                      onClick={function () {
                        nav(
                          `/dashboard/checkin/steps/step4/${order.quotationId}`
                        );
                      }}
                      style={{ minWidth: "5rem" }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>
                    {/*
                      <blockquote
                        style={{
                          pointerEvents: deletePermission() && "none",
                          width: "5rem",
                        }}
                        onClick={() => {
                          Swal.fire({
                            icon: "error",
                            title: "Are You Sure?",
                            text: "This Order Will Get Permanently Deleted",
                            showCancelButton: true,
                            showConfirmButton: true,
                          }).then((x) => {
                            if (x.isConfirmed) {
                              axiosInstance
                                .delete(
                                  `${process.env.REACT_APP_API_URL}/api/Orders/PermanentDeleteOrder/${order.id}`
                                )
                                .then((res) => {
                                  handleCustomer(res.data.customerId);
                                  toast.success(res.data.message, {
                                    position: "bottom-center",
                                    theme: "dark",
                                  });
                                  setrefresh(!refresh);
                                })
                                .catch(console.log);
                            }
                          });
                        }}
                      >
                        <i
                          className="fa-solid fa-trash"
                          style={{
                            color: deletePermission() && "gray",
                          }}
                        ></i>
                      </blockquote>*/}
                  </aside>
                ))
              ) : (
                <aside style={{ gridTemplateColumns: "repeat(10, 1fr)" }}>
                  <blockquote style={{ gridColumn: "span 10" }}>
                    <center>No Orders Found</center>
                  </blockquote>
                </aside>
              )
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(10, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 10" }}>
                  <center>You Do Not Have Permission To Read Data</center>
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </div>
      <Pagination count={pages} setpagenumber={setpage} pagenumber={page} />
    </section>
  );
}

export default Orders;
